// Module
var code = "<kendo-grid id=\"teamsGrid\" k-scope-field=\"teamsGrid\" flowingly-grid grid-init-done=\"$ctrl.gridInitDone\" grid-need-resize=\"$ctrl.gridNeedResize\" offset=\"300\" no-rows=\"$ctrl.noRows\" options=\"$ctrl.options\" class=\"runner-grid-default\"> </kendo-grid> ";
// Exports
export default code;